
import { Query } from '@datorama/akita';
import { UserCategoriesState } from './user-categories.model';
import { userCategoriesStore, UserCategoriesStore } from './user-categories.store';

export class UserCategoriesQuery extends Query<UserCategoriesState> {
  constructor(protected store: UserCategoriesStore) {
    super(store);
  }
}

export const userCategoriesQuery = new UserCategoriesQuery(userCategoriesStore);